// Auto-enhances admin <select> dropdowns into searchable comboboxes by tagging
// them with data-controller="select-search". Stimulus then connects the
// controller (and handles its lifecycle across Turbo frame loads).
//
// Scoped to the admin (body[data-admin]); the public site is left untouched.
// Short selects are skipped unless data-searchable="true"; opt out any select
// with data-searchable="false".

const MIN_OPTIONS = 8

function enhance(root) {
  if (!document.body || !document.body.hasAttribute("data-admin")) return
  const scope = root && root.querySelectorAll ? root : document
  scope.querySelectorAll("select.select").forEach((sel) => {
    if (sel.dataset.ssTagged === "1" || sel.multiple) return
    if (sel.dataset.searchable === "false") return
    const forced = sel.dataset.searchable === "true"
    if (!forced && sel.querySelectorAll("option").length < MIN_OPTIONS) return

    sel.dataset.ssTagged = "1"
    const existing = sel.getAttribute("data-controller")
    sel.setAttribute("data-controller", existing ? `${existing} select-search` : "select-search")
  })
}

// Strip the injected combobox UI before Turbo caches the page, so a cached
// snapshot (back/forward navigation) is restored as clean native selects and
// re-enhanced fresh — never duplicated or left with dead (listener-less) UI.
function strip() {
  document.querySelectorAll("div[data-ss-wrap], ul[data-ss-list]").forEach((w) => w.remove())
  document.querySelectorAll("select[data-ss-ready], select[data-ss-tagged]").forEach((sel) => {
    sel.classList.remove("sr-only")
    sel.removeAttribute("aria-hidden")
    sel.removeAttribute("tabindex")
    delete sel.dataset.ssReady
    delete sel.dataset.ssTagged
    const controllers = (sel.getAttribute("data-controller") || "")
      .split(/\s+/).filter((c) => c && c !== "select-search")
    if (controllers.length) sel.setAttribute("data-controller", controllers.join(" "))
    else sel.removeAttribute("data-controller")
  })
}

document.addEventListener("turbo:load", () => enhance(document))
document.addEventListener("turbo:render", () => enhance(document))
document.addEventListener("turbo:frame-load", (e) => enhance(e.target))
document.addEventListener("turbo:before-cache", () => strip())
document.addEventListener("DOMContentLoaded", () => enhance(document))
